import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisRequest = ApiDefinition['/ai/business-description']['POST'];
type Input = ThisRequest['body'];
type Output = ThisRequest['response'];

const generateBusinessDescription = async (payload: Input): Promise<Output> => {
  const response = await noodleApiClient.post('/ai/business-description', payload);
  return response.data;
};

export default generateBusinessDescription;
